export enum ReportDataType {
  ORDERS = "returns",
  PRODUCTS = "returned_products",
  WARRANTY_CUSTOMERS = "warranty_customers",
  PURCHASED_EXTENDED_WARRANTY = "purchased_extended_warranty",
}
